/* eslint-disable no-empty */
/* global require */

(function () {
  try {
    require('ember-cli-deprecation-workflow').default();
  } catch (e) {}
})();
